import clsx from 'clsx'
import type { UseFormRegisterReturn } from 'react-hook-form'
import { FormField } from '../base/FormField'
interface ContactInputProps {
  name: string
  label: string
  placeholder?: string
  required?: boolean
  error?: string
  helperText?: string
  register: UseFormRegisterReturn
  className?: string
  disabled?: boolean
}

export const ContactInput = ({ name, label, placeholder = "9876543210", required, error, helperText, register, className, disabled = false }: ContactInputProps) => {
    const showError = !!error

    return (
      <FormField 
        name={name} 
        label={label} 
        required={required} 
        error={error} 
        helperText={helperText}
        showError={showError}
      >
        <div className="relative">
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2 flex items-center text-[var(--text-secondary)]">
            <span className="font-medium text-sm">+91</span>
            <div className="w-px h-5 bg-[var(--border-default)] mx-3"></div>
          </div>
          <input
            {...register}
            id={name}
            type="tel"
            placeholder={placeholder}
            maxLength={10}
            inputMode="numeric"
            disabled={disabled}
            aria-invalid={showError || undefined}
            aria-describedby={showError && error ? `${name}-error` : undefined}
            className={clsx(
              'block w-full h-10 pl-16 rounded-md text-sm text-[var(--text-primary)] bg-[var(--surface-input)] transition-all duration-150 border focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-ring)] hover:border-[var(--border-strong)] placeholder:text-[var(--text-muted)]',
              'border-[var(--border-input)]',
              showError && 'border-[var(--status-error-border)] focus-visible:ring-[var(--status-error-text)]',
              disabled && 'opacity-50 cursor-not-allowed bg-[var(--surface-input-disabled)]',
              className
            )}
            autoComplete="tel"
            onKeyDown={(e) => {
              const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
              if (allowedKeys.includes(e.key)) return;
              if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x', 'z'].includes(e.key.toLowerCase())) return;
              if (!/^[0-9]$/.test(e.key)) e.preventDefault();
            }}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '').slice(0, 10);
              const nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set;
              nativeSetter?.call(e.target, value);
              register.onChange(e);
            }}
          />
        </div>
      </FormField>
    )
}

ContactInput.displayName = 'ContactInput'